import { ICallbackFormParams, ICreator, IHasCreator } from '@/interfaces';
import { FormCreateOrEditCreator } from '@/components/forms';
import { broadcastService } from '@/services';
import { TCallbackForm } from '@/types';

type TCreateParams = {
  callback?: (data: ICallbackFormParams<ICreator>) => void;
  requireReferralCode?: boolean;
};

type TSeeDetailsParams = {
  callback?: TCallbackForm<ICreator>;
  textBtnCancel?: string;
};

type TEditParams = Pick<TCreateParams, 'callback'> &
  IHasCreator;

const useFormCreator = () => {

  const seeDetails = (creator: ICreator, params?: TSeeDetailsParams) =>
    creator &&
    broadcastService
      .modal
      .show({
        content: (
          <FormCreateOrEditCreator
            readonly
            textBtnCancel={params?.textBtnCancel}
            callback={params?.callback}
            creator={creator} />
        ),
        width: 'lg'
      });

  const create = (params: TCreateParams) =>
    broadcastService
      .modal
      .show({
        content: <FormCreateOrEditCreator {...params} />,
        width: 'lg'
      });

  const edit = (params: TEditParams) =>
    params &&
    broadcastService
      .modal
      .show({
        content: (
          <FormCreateOrEditCreator
            callback={params.callback}
            creator={params.creator} />
        ),
        width: 'lg'
      });

  return ({
    seeDetails,
    create,
    edit
  });

};

export default useFormCreator;
